import { isArray } from '@rehaje/shared'

export function calcDepth(arr: any): number {
  return isArray(arr) ? Math.max(...arr.map(calcDepth)) + 1 : 0
}
